import React from 'react';
import { Column } from '@ydistri/ds';

/**
 * Description of a margin to be displayed in a tooltip.
 */
const MarginDescription: React.FC = () => {
  return (
    <Column>
      Computed from:
      <ul>
        <li>Sale price of sale transactions</li>
        <li>Cost price from inventory</li>
      </ul>
      Only non-sellout sales from last 90 days are considered
    </Column>
  );
};

export default MarginDescription;
